import { SerializedError } from '@reduxjs/toolkit';
import { FetchBaseQueryError } from '@reduxjs/toolkit/query';
import {
  Effects,
  ExtraFormulaFields,
  FormulaFields,
} from 'services/store/remixer/types';
import { AnalyticsEventLocation } from '../entities';
import AnalyticsEvent from './analyticsEvent';

const remixerEvents = {
  studioButtonClick: (location: AnalyticsEventLocation): AnalyticsEvent =>
    AnalyticsEvent.createEvent('studio_button_click', { location }),
  studioUndoButtonClick: (): AnalyticsEvent =>
    AnalyticsEvent.createEvent('studio_undo_button_click'),
  studioRedoButtonClick: (): AnalyticsEvent =>
    AnalyticsEvent.createEvent('studio_redo_button_click'),
  studioRemixApplied: (
    studioFeature: FormulaFields | ExtraFormulaFields
  ): AnalyticsEvent =>
    AnalyticsEvent.createEvent('studio_remix_applied', {
      studio_feature: studioFeature,
    }),
  studioError: (
    error: SerializedError | FetchBaseQueryError
  ): AnalyticsEvent => {
    if ('error' in error) {
      return AnalyticsEvent.createEvent('studio_error', {
        status_code: error.status,
        message: error.error,
      });
    }
    if ('code' in error) {
      return AnalyticsEvent.createEvent('studio_error', {
        status_code: error.code,
        title: error.name,
        message: error.message,
      });
    }
    return AnalyticsEvent.createEvent('studio_error', {
      message: 'uncought studio error',
    });
  },
  studioExportClick: (fxContent: Record<Effects, number>): AnalyticsEvent =>
    AnalyticsEvent.createEvent('studio_export_click', {
      fx_content: fxContent,
    }),
  studioExport: (fxContent: Record<Effects, number>): AnalyticsEvent =>
    AnalyticsEvent.createEvent('studio_export', {
      fx_content: fxContent,
    }),

  studioProjectSave: (location: AnalyticsEventLocation): AnalyticsEvent =>
    AnalyticsEvent.createEvent('studio_project_save', { location }),

  studioRender: (data: Record<string, unknown>): AnalyticsEvent =>
    AnalyticsEvent.createEvent('studio_render', data),
};

export default remixerEvents;
